export default "__VITE_ASSET__t9YNhpUs__"